import { useParams } from 'react-router-dom'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { InputTableURLsTable } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { QuoteOrderStatusInversed } from '@teinor/erp/types/company/order/quote/quoteOrder'
import QuoteOrderCreateStep from './Steps/QuoteOrderCreateStep'
import QuoteOrderFinishedStep from './Steps/QuoteOrderFinishedStep'
import QuoteOrderWaitingResponseStep from './Steps/QuoteOrderWaitingResponseStep'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import QuoteOrderCreateNoPermissionStep from './Steps/QuoteOrderCreateNoPermissionStep'
import { getUserPermissions } from '../../../../../../../utils/reducers/getters'
import useOrderScreenLogic from '../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/useOrderScreenLogic'


interface SingleQuoteOrderProps extends TableComponentProps { }

const SingleQuoteOrder: React.FC<SingleQuoteOrderProps> = ({ userPermissions }) => {
    const params = useParams<{ id: string }>()
    const OrderId = params.id

    const inputTableURLs: InputTableURLsTable = {
        createData: ['/api/app/order/quote/orderProduct/createQuoteOrderProduct', { OrderId }],
        getData: ['/api/app/order/quote/getQuoteOrderComplete', { id: OrderId }],
        updateData: '/api/app/order/quote/orderProduct/updateQuoteOrderProduct',
        delete: '/api/app/order/quote/orderProduct/deleteQuoteOrderProduct',
        updateHeaderData: '/api/app/order/quote/updateQuoteOrder',
        updateOrderLines: '/api/app/order/quote/updateQuoteOrderNLines',
        getSubProducts: ['/api/app/order/quote/orderProduct/getAllSubQuoteProducts', ['CustomerId']],
        printTags: ''
    }
    const { completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration, headerChanges } = useOrderScreenLogic({ inputTableURLs, userPermissions: 'quote.order' })
    const status = parseInt(completeData?.header.status)
    if (!permissionCheck(getUserPermissions('quote.order'), 'update') || completeData?.header.hidePrices || completeData?.header.notModificable) {
        return <QuoteOrderCreateNoPermissionStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    } else if (status === QuoteOrderStatusInversed['waitingResponse'] || status === QuoteOrderStatusInversed['sent']) {
        return <QuoteOrderWaitingResponseStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    } else if (status === QuoteOrderStatusInversed['denied'] || status === QuoteOrderStatusInversed['accepted'] || status === QuoteOrderStatusInversed['processed']) {
        return <QuoteOrderFinishedStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    }
    return <QuoteOrderCreateStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
}

export default SingleQuoteOrder